import { useHistory } from 'react-router-dom'
import { ErrorBoundary, init } from '@sentry/react'
import PropTypes from 'prop-types'

if (process.env.MATRIX_DSN) {
  try {
    init({
      dsn: process.env.MATRIX_DSN,
      release: process.env.MATRIX_RELEASE,
      allowUrls: [window.location.origin],
      normalizeDepth: 10,
    })
  } catch (e) {
    console.error(e)
  }
}
const MatrixErrorBoundary = ({ children }) => {
  const history = useHistory()
  return (
    <ErrorBoundary onError={() => history.replace('/error/500')}>
      {children}
    </ErrorBoundary>
  )
}
MatrixErrorBoundary.propTypes = {
  children: PropTypes.node,
}
export default MatrixErrorBoundary
